var _a;
import React from "react";
import { Provider as FluentUIThemeProvider, mergeThemes, teamsTheme, teamsDarkTheme, teamsHighContrastTheme, } from "@fluentui/react-northstar";
import { defaultV2ThemeOverrides, darkV2ThemeOverrides, highContrastThemeOverrides, TeamsTheme, } from "../themes";
import { default as builtInTranslations, } from "../translations";
export var IThemeTeamsClient;
(function (IThemeTeamsClient) {
    IThemeTeamsClient["HighContrast"] = "contrast";
    IThemeTeamsClient["Dark"] = "dark";
    IThemeTeamsClient["Default"] = "default";
})(IThemeTeamsClient || (IThemeTeamsClient = {}));
export var teamsNextVariableAssignments = {
    componentVariables: {
        TableRow: function (_a) {
            var colorScheme = _a.colorScheme;
            return ({
                color: colorScheme.default.foreground1,
            });
        },
    },
    componentStyles: {
        Box: {
            root: function (_a) {
                var variables = _a.variables;
                return ({
                    color: variables.color,
                    backgroundColor: variables.backgroundColor,
                    boxShadow: variables.elevation,
                });
            },
        },
        ButtonContent: {
            root: function (_a) {
                var variables = _a.variables;
                return ({
                    fontWeight: variables.fontWeight,
                });
            },
        },
        Card: {
            root: function (_a) {
                var variables = _a.variables;
                return ({
                    boxShadow: variables.elevation,
                    "&:hover": { boxShadow: variables.hoverElevation },
                    "&:focus": { boxShadow: variables.elevation },
                });
            },
        },
        Flex: {
            root: function (_a) {
                var variables = _a.variables;
                return ({
                    color: variables.color,
                    backgroundColor: variables.backgroundColor,
                    boxShadow: variables.elevation,
                });
            },
        },
        ToolbarItem: {
            root: function (_a) {
                var variables = _a.variables;
                return ({
                    color: variables.color,
                    fontWeight: variables.fontWeight,
                });
            },
        },
        PopupContent: {
            content: function (_a) {
                var variables = _a.variables;
                return ({
                    boxShadow: variables.elevation,
                    borderWidth: variables.borderWidth,
                });
            },
        },
        PopupButton: {
            root: function (_a) {
                var variables = _a.variables;
                return ({
                    color: variables.color,
                });
            },
        },
        TableRow: {
            root: function (_a) {
                var variables = _a.variables;
                return {
                    height: variables.compactRow
                        ? variables.compactRowHeight
                        : variables.defaultRowHeight,
                    minHeight: variables.compactRow
                        ? variables.compactRowMinHeight
                        : variables.defaultRowMinHeight,
                    alignItems: variables.cellVerticalAlignment,
                };
            },
        },
        TableCell: {
            root: function (_a) {
                var variables = _a.variables;
                return ({
                    paddingTop: variables.compactRow
                        ? variables.compactRowVerticalPadding
                        : variables.defaultRowVerticalPadding,
                    paddingBottom: variables.compactRow
                        ? variables.compactRowVerticalPadding
                        : variables.defaultRowVerticalPadding,
                });
            },
        },
        TreeItem: {
            root: function (_a) {
                var variables = _a.variables;
                return ({
                    color: variables.color,
                });
            },
        },
    },
};
export var themes = (_a = {},
    _a[TeamsTheme.Default] = mergeThemes(teamsTheme, teamsNextVariableAssignments, defaultV2ThemeOverrides),
    _a[TeamsTheme.Dark] = mergeThemes(teamsDarkTheme, teamsNextVariableAssignments, darkV2ThemeOverrides),
    _a[TeamsTheme.HighContrast] = mergeThemes(teamsHighContrastTheme, teamsNextVariableAssignments, highContrastThemeOverrides),
    _a);
export var HVCThemeProvider = function (_a) {
    // [v-wishow] todo: translations will (presumably) eventually need to be loaded asynchronously
    var _b, _c, _d;
    var children = _a.children, lang = _a.lang, themeName = _a.themeName, translations = _a.translations;
    switch (themeName) {
        case IThemeTeamsClient.Dark:
            themeName = TeamsTheme.Dark;
            break;
        case IThemeTeamsClient.Default:
            themeName = TeamsTheme.Default;
            break;
        case IThemeTeamsClient.HighContrast:
            themeName = TeamsTheme.HighContrast;
            break;
    }
    var theme = themes[themeName];
    var rtl = lang === "fa";
    if (theme.siteVariables) {
        theme.siteVariables.lang = lang;
        theme.siteVariables.rtl = rtl;
        theme.siteVariables.t =
            (translations && translations[lang]) || builtInTranslations[lang];
    }
    return (React.createElement(FluentUIThemeProvider, { theme: theme, rtl: rtl, style: {
            backgroundColor: theme.siteVariables &&
                theme.siteVariables.colorScheme.default.background2,
        } },
        React.createElement("style", null, "\n          html, body, #root, #root > .ui-provider { height: 100% }\n          ::-webkit-scrollbar { width: .75rem } \n          ::-webkit-scrollbar-track {\n            background-color: " + ((_b = theme.siteVariables) === null || _b === void 0 ? void 0 : _b.colorScheme.default.background2) + ";\n          }\n          ::-webkit-scrollbar-thumb {\n            background-color: " + ((_c = theme.siteVariables) === null || _c === void 0 ? void 0 : _c.colorScheme.onyx.border2) + ";\n            border-radius: .75rem;\n            border: 3px solid transparent;\n            background-clip: content-box;\n          }\n          ::-webkit-scrollbar-thumb:hover {\n            background-color: " + ((_d = theme.siteVariables) === null || _d === void 0 ? void 0 : _d.colorScheme.default.foreground2) + ";\n          } \n        "),
        children));
};
//# sourceMappingURL=withTheme.js.map